'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mixin = require('./mixin');

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/prop-types */


exports["default"] = _react2["default"].createClass({
  displayName: 'Circle',

  mixins: [_mixin2["default"]],
  render: function render() {
    var _this = this;

    var _props = this.props;
    var prefixCls = _props.prefixCls;
    var strokeWidth = _props.strokeWidth;
    var trailWidth = _props.trailWidth;
    var strokeColor = _props.strokeColor;
    var trailColor = _props.trailColor;
    var strokeLinecap = _props.strokeLinecap;
    var percent = _props.percent;
    var style = _props.style;
    var className = _props.className;

    var restProps = _objectWithoutProperties(_props, ['prefixCls', 'strokeWidth', 'trailWidth', 'strokeColor', 'trailColor', 'strokeLinecap', 'percent', 'style', 'className']);

    var radius = 50 - strokeWidth / 2;
    var pathString = 'M 50,50 m 0,-' + radius + '\n     a ' + radius + ',' + radius + ' 0 1 1 0,' + 2 * radius + '\n     a ' + radius + ',' + radius + ' 0 1 1 0,-' + 2 * radius;
    var len = Math.PI * 2 * radius;
    var pathStyle = {
      strokeDasharray: len + 'px ' + len + 'px',
      strokeDashoffset: (100 - percent) / 100 * len + 'px',
      transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s ease'
    };

    return _react2["default"].createElement(
      'svg',
      _extends({
        className: prefixCls + '-circle ' + className,
        viewBox: '0 0 100 100',
        style: style
      }, restProps),
      _react2["default"].createElement('path', {
        className: prefixCls + '-circle-trail',
        d: pathString,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: '0'
      }),
      _react2["default"].createElement('path', {
        className: prefixCls + '-circle-path',
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        fillOpacity: '0',
        ref: function ref(path) {
          _this.path = path;
        },
        style: pathStyle
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-progress/lib/Circle.js
// module id = 747
// module chunks = 0